import isEqual from 'lodash.isequal';
import React from 'react';
import { useParams } from 'react-router';
import {
  DashboardNotAllowedError,
  DashboardNotFoundError,
} from '../../../api/dashboards/dashboard-errors';
import { useGetUserViewCustomDashboardConfig } from '../../../api/dashboards/hooks';
import { startDateField } from '../../../constants';
import {
  FilterSectionsContext,
  SegmentationSectionsContext,
  useGlobalTimeSliderContext,
} from '../../../context/contexts';
import { DataTypes } from '../../../types';
import { BetterLoadingOverlay } from '../BetterLoading';
import { BetterSuspense } from '../BetterSuspense';
import { useAllowedFields, useAvailableFilterSections } from '../filter/hooks';
import CustomDashboard from './CustomDashboard';
import { DashboardId } from './types';

const CustomDashboardWrapperInner = () => {
  const { dashboardId = '', pageNumber } = useParams<{
    dashboardId: DashboardId | undefined;
    pageNumber: string | undefined;
  }>();

  if (!dashboardId) {
    throw new Error(`Couldn't find dashboard id`);
  }
  const dashboardConfig = useGetUserViewCustomDashboardConfig(dashboardId);

  const timeSliderHandle = useGlobalTimeSliderContext();
  const [timeSliderState] = timeSliderHandle;
  const allowedFields = useAllowedFields();

  const filters =
    allowedFields?.filter((f) =>
      [DataTypes.EMPLOYEE, DataTypes.EVALUATION].includes(f.dataType)
    ) ?? [];
  const segments =
    allowedFields?.filter((f) => [DataTypes.EMPLOYEE].includes(f.dataType)) ??
    [];

  const filterSections = useAvailableFilterSections(
    'filter',
    filters,
    timeSliderState
  );
  const segmentationSections = useAvailableFilterSections(
    'segmentation',
    segments.filter((f) => !isEqual(f, startDateField)),
    timeSliderState
  );

  if (dashboardConfig instanceof DashboardNotFoundError) {
    return <div>{dashboardConfig.message}</div>;
  } else if (dashboardConfig instanceof DashboardNotAllowedError) {
    return <div>{dashboardConfig.message}</div>;
  } else {
    return (
      <FilterSectionsContext.Provider value={filterSections}>
        <SegmentationSectionsContext.Provider value={segmentationSections}>
          <CustomDashboard
            dashboardConfig={dashboardConfig}
            selectedPageNumber={Number(pageNumber)}
          />
        </SegmentationSectionsContext.Provider>
      </FilterSectionsContext.Provider>
    );
  }
};

const CustomDashboardWrapper = () => {
  return (
    <BetterSuspense
      fallback={
        <BetterLoadingOverlay
          debugString="CustomDashboardWrapper"
          isPending={false}
        />
      }
      wait={0}
      freez={0}
    >
      <CustomDashboardWrapperInner />
    </BetterSuspense>
  );
};

export default CustomDashboardWrapper;
